import { render, staticRenderFns } from "./ItemDash.vue?vue&type=template&id=38d5d3b6"
import script from "./ItemDash.vue?vue&type=script&lang=js"
export * from "./ItemDash.vue?vue&type=script&lang=js"
import style0 from "./ItemDash.vue?vue&type=style&index=0&id=38d5d3b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports